<template>
    <b-modal
        v-model="showModal"
        size="lg"
        centered
        hide-footer
        title="Are you sure you want to remove this record?"
        header-bg-variant="danger"
        @change="onChange"
    >
        <div class="d-block text-center">
            <h5>If you're sure you want to remove this record, click <strong>Yes</strong>.</h5>
            <b-row class="d-block text-center">
                <b-button variant="danger" size="md" @click="removeElement(recordId)">Yes</b-button>
                <span class="pad-buttons" />
                <b-button variant="success" size="md" @click="closeModal">No</b-button>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        removeElement: {
            type: Function,
            required: true,
        },
        recordId: {
            type: String,
        },
    },
    watch: {
        value() {
            this.showModal = this.value
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        closeModal() {
            this.showModal = false
            this.$emit('input', this.showModal)
            this.$emit('close')
        },
        onChange() {
            this.$emit('input', this.showModal)
        },
    },
}
</script>

<style>
.pad-buttons {
    padding-left: 2rem;
}
</style>
